import "@design/tokens.css";
import "@design/werkzeuge/vorschau/stil.css";
import "./design/app.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { firebaseStarten } from "./plattform/firebase";
import { konfigurationLaden, umzugsweiterleitung } from "./plattform/konfiguration";
import { offlineVorbereiten } from "./plattform/offline";
import { lebenszyklusStarten } from "./plattform/lebenszyklus";
import { serviceWorkerRegistrieren } from "./plattform/serviceworker";
import { warteschlangeStarten } from "./plattform/warteschlange";

/**
 * Start der PWA: Laufzeitkonfiguration (im Umzugsmodus der alten Adresse außer am Start weiter zur neuen), Offline-Daten
 * eines vergangenen Jagdtags löschen (K31), Firebase (am Jagdtag mit persistentem Cache), Service Worker mit dem
 * Lebenszyklus der Versionen (ADR-0041), Warteschlange, dann die Oberfläche (ADR-0027).
 * Das Referenz-CSS des Designsystems (design/werkzeuge/vorschau/stil.css, Abschnitt B) gilt unverändert.
 */
async function starten() {
  const konfig = await konfigurationLaden();
  const weiter = umzugsweiterleitung(konfig, window.location);
  if (weiter) {
    window.location.replace(weiter);
    return;
  }
  firebaseStarten(konfig, await offlineVorbereiten());
  void serviceWorkerRegistrieren().then(lebenszyklusStarten);
  // Im Umzugsmodus nimmt die alte Adresse nichts mehr an; wartende Meldungen bleiben liegen (gesendet, falls er endet).
  if (!konfig.umzug) warteschlangeStarten();
  createRoot(document.getElementById("app")!).render(<StrictMode><App /></StrictMode>);
}

void starten();
